<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" label-width="90px" :rules="rules" ref="dialogForm" class="label-gray">
      <el-form-item label="角色名称" prop="name">
        <el-input v-model.trim="dialogForm.name" clearable maxLength="18"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="describe">
        <el-input v-model.trim="dialogForm.describe" clearable></el-input>
      </el-form-item>
      <el-form-item prop="permission_id" class="routes-tree-item">
        <template slot="label">
          <el-tooltip effect="dark" content="您可在权限管理中添加访问权限" placement="top-start">
            <el-button class="tips" icon="el-icon-info">权限</el-button>
          </el-tooltip>
        </template>
        <el-tree :data="permissions"
                 :props="defaultProps"
                 @check="treeCheck"
                 ref="tree"
                 :render-content="treeContent"
                 :indent="35"
                 show-checkbox
                 empty-text="暂无权限，请在权限管理中添加访问权限"
                 node-key="permissionId">
        </el-tree>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkNickName} from '@utils/validate'
  import {getRoutesTree} from '@router/permission'
  export default {
    name: "RoleOperate",
    props: {dialogData: Object},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        dialogForm: {
          name: "",
          describe: "",
          permission_id: "",
        },
        rules: {
          name: [inputEmpty("角色名称"),checkNickName()],
          permission_id: [changeEmpty("权限")],
        },
        permissions: []
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
        this.init(row);
      } else {
        this.getPermission();
      }
    },
    methods: {
      treeContent(h, {data}) {
        return h("span", {class: data.icon}, data.label);
      },
      treeCheck(data, tree) {
        let list = tree.checkedKeys.filter(item => item);
        this.dialogForm.permission_id = list.join(",");
        this.$refs["dialogForm"].validateField("permission_id");
      },
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addRole(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val;
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该角色", async () => {
                nv.optionId = row.id;
                let res = await this.$Http.reviseRole(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
      async init(row) {
        let p1 = this.$Http.getPermissionList;
        let p2 = this.$Http.getRolePermission;
        let [res1, res2] = await Promise.all([p1({page:1, limit: 50}),p2({role_id: row.id})]);
        if (res1 && res2) {
          let list1 = this.getArray(res1.data.list);
          let list2 = this.getArray(res2.data);
          this.permissions = getRoutesTree(list1);
          let permissionIdList = list2.map(item => item.id);
          this.dialogForm.permission_id = permissionIdList.join(",");
          row.permission_id = permissionIdList.join(",");
          this.$nextTick(() => this.$refs.tree.setCheckedKeys(permissionIdList));
        }
      },
      async getPermission() {
        let nv = {page:1, limit: 50};
        let res = await this.$Http.getPermissionList(nv);
        if (res?.data) {
          let list = this.getArray(res.data.list);
          this.permissions = getRoutesTree(list);
        }
      },
    }
  }
</script>

<style scoped>

</style>
